import { render, staticRenderFns } from "./PreguntasExamen.vue?vue&type=template&id=0e85b0b1&"
import script from "./PreguntasExamen.vue?vue&type=script&lang=js&"
export * from "./PreguntasExamen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports